import React, {forwardRef, useEffect, useRef, useState} from "react";
import {DEFAULT_TIPTAP_FONT_SIZE, DEFAULT_TIPTAP_FONT_SIZE_IN_CANVAS, MAX_Z_INDEX} from "../../../../../src/Const";
import {
    decodeDeeplink,
    generateUUID2,
    getImagePathWithSvg,
    getImagePathWithTheme,
    getImagePathWithThemeSvg
} from "../../../../../src/utils";
import ColorPickers from "../../../../../src/components/EditorV2/ColorPicker";
import TurnNewCard from "../../../../../src/components/EditorV2/TurnNewCard/TurnNewCard";
import HighlightPicker from "../../../../../src/components/EditorV2/HighlightPicker/HighlightPicker";
import { Dropdown } from "antd";
import { t } from "i18next";
import style from "./CardEdit.module.less";
import global from "../../../../../src/global";
import {getCardById} from "../../../../../model";
import InputNumberExt from "../../../../../src/common/InputNumberExt";

const CardEditBubbleMenu = forwardRef((props:{app:any,editor:any,updateEditCardHtml:any,syncNoteData:any,element:any;data:any,onHiddenBubbleMenu:any,onAction:any,from:any},ref)=> {
    const {app,editor,updateEditCardHtml,syncNoteData,element,data,onHiddenBubbleMenu} = props;

    const [position,setPosition] = useState({x:0,y:0});
    useEffect(() => {
        updatePostion();
    }, []);

    useEffect(()=>{
        window.updateBubblePosition = ()=>{
            updatePostion();
        }

        return ()=>{
            delete window.updateBubblePosition;
        }
    })

    const updatePostion = ()=>{
        var fRate = app.state.zoom.value;
        var fScrollX = app.state.scrollX * fRate;
        var fScrollY = app.state.scrollY * fRate;

        let left = element.x * fRate + fScrollX;
        let top = (element.y * fRate - 52) + fScrollY;

        let {from,to} = editor.state.selection;
        let start = from;
        let end = to;
        if (to > from){
            start = to;
            end = from;
        }
        const startCoords = editor.view.coordsAtPos(start);
        const endCoords = editor.view.coordsAtPos(end);
        // console.log('选区坐标范围:', startCoords, endCoords);
        left = startCoords.left - 370*0.5;
        top = endCoords.top - 44;

        setPosition({x:left,y:top})
    }


    return <div style={{position:'fixed',left:`${position.x}px`,top:`${position.y}px`,zIndex:MAX_Z_INDEX,display:(position.x == 0 && position.y == 0)?'none':'inherit'}}>
        <div className={style.action} style={{display: 'grid', width: '100%'}}>
            <Dropdown overlayStyle={{fontSize: '12px', zIndex: MAX_Z_INDEX}} menu={{
                items: [
                    {
                        label: t('Text'),
                        key: ''
                    }, {
                        label: t('H1'),
                        key: 1
                    }, {
                        label: t('H2'),
                        key: 2
                    }, {
                        label: t('H3'),
                        key: 3
                    }, {
                        label: t('H4'),
                        key: 4
                    }, {
                        label: t('H5'),
                        key: 5
                    }, {
                        label: t('H6'),
                        key: 6
                    }, {
                        label: t('Todo'),
                        key: 7
                    }, {
                        label: t('Number list'),
                        key: 8
                    }, {
                        label: t('Bullet list'),
                        key: 9
                    }
                ], async onClick(event) {
                    const e = Number(event.key)
                    // 判断当前是不是list节点 转文本
                    const {from} = editor.state.selection
                    const resolvedPos = editor.state.doc.resolve(from);
                    const currentNode = resolvedPos.node();
                    const parentNode = resolvedPos.node(resolvedPos.depth - 1);

                    // debugger
                    if ([1, 2, 3, 4, 5, 6].includes(e)) {
                        editor.chain().focus().setHeading({level: e,id:generateUUID2()}).run()
                    } else if (e === 7 && parentNode.type.name !== 'taskItem') {
                        editor
                            .chain()
                            .focus()
                            .toggleTaskList()
                            .run()
                    } else if (e === 8 && !(parentNode.type.name === 'listItem' && resolvedPos.depth - 2 > -1 && resolvedPos.node(resolvedPos.depth - 2).type.name === 'orderedList')) {
                        // 如果是自己类型地list转过来需要检验 不通过
                        // 如果是非自己类型地list转过来需要检验 通过
                        // 如果是非list 通过
                        editor
                            .chain()
                            .focus()
                            .toggleOrderedList()
                            .run()
                    } else if (e === 9 && !(parentNode.type.name === 'listItem' && resolvedPos.depth - 2 > -1 && resolvedPos.node(resolvedPos.depth - 2).type.name === 'bulletList')) {
                        editor
                            .chain()
                            .focus()
                            .toggleBulletList()
                            .run()
                    } else if (e === 0) {
                        if (parentNode.type.name === 'listItem' || parentNode.type.name === 'taskItem') {
                            const grandNode = resolvedPos.node(resolvedPos.depth - 2);
                            if (grandNode.type.name === 'orderedList') {
                                editor
                                    .chain()
                                    .focus()
                                    .toggleOrderedList()
                                    .run()
                            } else if (grandNode.type.name === 'bulletList') {
                                editor
                                    .chain()
                                    .focus()
                                    .toggleBulletList()
                                    .run()
                            } else if (grandNode.type.name === 'taskList') {
                                editor
                                    .chain()
                                    .focus()
                                    .toggleTaskList()
                                    .run()
                            }

                        } else {
                            editor.chain().focus().setParagraph().run()
                        }
                    }
                    updateEditCardHtml();
                    props.onAction('h1Changed')
                }
            }}>
                <div className='flex-row-vertical-center' style={{
                    marginLeft: '4px',
                    paddingLeft: '2px',
                    width: '100%',
                    whiteSpace: 'nowrap'
                }}>
                                  <span className={'default-font-family'} style={{fontSize: '13px'}}>
                                    {editor.isActive('heading', {level: 1}) ? t('H1') :
                                        editor.isActive('heading', {level: 2}) ? t('H2') :
                                            editor.isActive('heading', {level: 3}) ? t('H3') : t('Text')
                                    }
                                  </span>
                    <img className='img-28' style={{marginTop: '-1px'}}
                         src={getImagePathWithTheme('note_tool_dropdown')}/>

                </div>
            </Dropdown>

            <div className={'line-card-h-split'}></div>

            <div
                className={editor.isActive("bold") ? style.act : null}
                onClick={() => {
                    editor.chain().focus().toggleBold().run();
                    updateEditCardHtml();
                    props.app.pushHistory();
                }}
                title={t("Bold")}
            >
                {/*<TextBold theme="outline" size="16" fill="#333" />*/}
                <img className='img-28'
                     src={getImagePathWithTheme('note_tool_bold' + (editor.isActive("bold") ? '_selected' : ''))}/>
            </div>
            <div
                className={editor.isActive("italic") ? style.act : null}
                onClick={() => {
                    editor.chain().focus().toggleItalic().run();
                    updateEditCardHtml();
                    props.app.pushHistory();
                }}
                title={t("Italic")}
            >
                {/*<TextItalic theme="outline" size="16" fill="#333" />*/}
                <img className='img-28'
                     src={getImagePathWithTheme('note_tool_italic' + (editor.isActive("italic") ? '_selected' : ''))}/>
            </div>
            <div
                className={editor.isActive("underline") ? style.act : null}
                onClick={() => {
                    editor.chain().focus().toggleUnderline().run();
                    updateEditCardHtml();
                    props.app.pushHistory();
                }}
                title={t("Underline")}
            >
                {/*<TextUnderline theme="outline" size="16" fill="#333" />*/}
                <img className='img-28'
                     src={getImagePathWithTheme('note_tool_underline' + (editor.isActive("underline") ? '_selected' : ''))}/>
            </div>
            <div
                className={editor.isActive("strike") ? style.act : null}
                onClick={() => {
                    editor.chain().focus().toggleStrike().run();
                    updateEditCardHtml();
                    props.app.pushHistory();
                }}
                title={t("Strokethrough")}
            >
                {/*<Strikethrough theme="outline" size="16" fill="#333"/>*/}
                <img className='img-28'
                     src={getImagePathWithTheme('note_tool_strikethrough' + (editor.isActive("strike") ? '_selected' : ''))}/>
            </div>
            <div
                className={
                    editor.isActive({textAlign: "center"}) ? style.act : null
                }
                onClick={() => {
                    editor.isActive({textAlign: "center"})
                        ? editor.chain().focus().setTextAlign("left").run()
                        : editor.chain().focus().setTextAlign("center").run()
                    updateEditCardHtml();
                    props.app.pushHistory();
                }}
                title={t("Align")}
            >
                {/*<AlignTextCenter theme="outline" size="16" fill="#333" />*/}
                <img className='img-28'
                     src={getImagePathWithTheme('note_tool_align' + (editor.isActive({textAlign: "center"}) ? '_selected' : ''))}/>
            </div>

            <div
                className={editor.isActive('code') ? style.act : null}
                onClick={() => editor.chain().focus().toggleCode().run()}
                title={t("InlineCode")}
            >
                <img className='img-28'
                     src={editor.isActive('code') ? getImagePathWithSvg('node_tool_code_block_selected') : getImagePathWithThemeSvg('node_tool_code_block')}/>
            </div>

            <div className={'line-card-h-split'}></div>

            <InputNumberExt value={ editor.getAttributes('textStyle').fontSize?.replace('px', '') || DEFAULT_TIPTAP_FONT_SIZE_IN_CANVAS} onValueChanged={(value)=>{
                editor.chain().focus().setFontSize(`${value}px`).run();
            }}/>

            <div style={{margin: '0 8px 0 14px', display: 'flex'}}>
                <ColorPickers editor={editor} updateEditCardHtml={updateEditCardHtml}/>
            </div>
            <div className={'line-card-h-split'}></div>

            <div
                className={
                    editor.getAttributes('link').href ? style.act : null
                }
                onClick={() => {
                    const text = editor.state.selection.content()?.content?.content?.[0]?.textContent;
                    global.g_newCardTitle = text;

                    let link = editor.getAttributes('link').href

                    // window.showDialogCardLink({link, text}, (r: any) => {
                    //     if (r?.delete) {
                    //         editor.commands.unsetLink()
                    //         // editor.commands.unsetHyperlink()
                    //     } else if (r) {
                    //         editor.commands.setLink({href: r.link, target: '_blank'})
                    //         // editor.commands.setHyperlink({href: r.link, target: '_blank'})
                    //     }
                    //
                    //     updateEditCardHtml();
                    //     props.app.pushHistory();
                    // })
                    //关闭editor的焦点，以防止粘贴图片到库中的问题。。。
                    editor.commands.blur();

                    onHiddenBubbleMenu();

                    window.showDialogLink(link, 'card', async (item) => {
                        if (!item) {
                            editor.commands.unsetLink()
                            // editor.commands.unsetHyperlink()
                        } else {
                            editor.commands.setLink({href: item, target: '_blank'});

                            const deeplink = decodeDeeplink(item);
                            const card = await getCardById(deeplink.id);
                            if (card){
                                if ((Date.now() - card.createTime) < 2000){
                                    //认为是新建的卡片....
                                    window.showMessageTip(t('CardCreated1'),t('View'),'editCard',()=>{
                                        window.showDialogCard(card);
                                    });
                                }
                            }
                        }
                        // setTimeout(() => {
                        //     window.hookATags();
                        // }, 600)

                        updateEditCardHtml();
                        if (syncNoteData){
                            syncNoteData(null, true);
                        }

                        props.app.pushHistory();
                    })

                }
                }>
                {/*<LinkIcon theme="outline" size="16" fill="#333" />*/}
                <img className='img-20'
                     src={getImagePathWithTheme('card_bubble_menu_link' + (editor.getAttributes('link').href ? '_selected' : ''))}/>
            </div>

            {
                props.from != 'stickynote' &&
                <>
                    <div className={'line-card-h-split'}></div>
                    <div style={{
                        margin: '0 6px 0 0',
                        display: 'flex',
                        width: '100%',
                        cursor: 'pointer',
                        paddingRight: '0px'
                    }}>
                        <TurnNewCard editor={editor} onTurnCallback={() => {
                            onHiddenBubbleMenu();
                            updateEditCardHtml();
                            if (syncNoteData) {
                                syncNoteData(null, true);
                            }

                        }}/>
                    </div>

                    <div className={'line-card-h-split'}></div>
                    <div style={{margin: '0 4px', display: 'flex', width: '100%', cursor: 'pointer'}}>
                        <HighlightPicker editor={editor} data={props.data} updateEditCardHtml={() => {
                            updateEditCardHtml();
                            //刷新content
                            if (window.onRefreshElement) {
                                window.onRefreshElement(props.app.getSceneElements());
                            }
                        }}/>
                    </div>
                </>
            }
        </div>
    </div>
})

export default CardEditBubbleMenu;